export default __webpack_public_path__ + "static/media/about-us-small.5209f29d.jpg";